import { render } from "./ThemeButtonCopy.vue?vue&type=template&id=6e328486"
import script from "./ThemeButtonCopy.vue?vue&type=script&lang=js"
export * from "./ThemeButtonCopy.vue?vue&type=script&lang=js"

import exportComponent from "/Users/djones/Desktop/repos/davyjones-me/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__